// extracted by mini-css-extract-plugin
export default {"container":"CSelect_container__f0il6","label":"CSelect_label__-7JVR","select":"CSelect_select__o7Z7Q"};